<template>
  <div>
    <div class="search-form">
      <div class="search-form-left">
        <div class="form">
          <a-form-model
            :model="form"
            layout="inline"
          >
            <a-form-model-item
              label="基地："
              prop="baseId"
            >
              <a-select
                v-model="form.baseId"
                placeholder="请选择基地"
                allow-clear
                show-search
                :filter-option="filterOption"
                @inputKeydown="inputKeydown($event, checkResource)"
              >
                <a-select-option
                  v-for="item in baseOptions"
                  :key="item.baseId"
                >
                  {{ item.baseName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-form-model>
        </div>
        <div class="ant-btns-mrright">
          <TableActions
            :actions="headerActions"
            @checkResource="checkResource"
          />
        </div>
      </div>

      <div class="search-form-right">
        <TableActions
          :actions="addActions"
          @add="addPaymentRecord"
          @exportResource="exportCollections"
        />
      </div>
    </div>

    <div class="table">
      <a-table
        :columns="columns"
        :data-source="dataSource"
        :loading="loading"
        :pagination="pagination"
        style="padding: 16px 0; background-color: #fff;"
        :row-key="(item, index) => item.baseId + index"
        :scroll="{ x: 1200 }"
        @change="handleTableChange"
      >
        <template
          slot="collectionDate"
          slot-scope="collectionDate"
        >
          {{ moment(collectionDate).format('YYYY-MM-DD') }}
        </template>

        <span
          slot="actions"
          slot-scope="text, record"
        >
          <TableActions
            :actions="tableActions"
            :record="record"
            @edit="editPaymentRecord(record)"
            @delete="handleDelete(record)"
          />
        </span>
      </a-table>
    </div>
    <EditPaymentRecord
      :init-data="initData"
      :dialog-title="dialogTitle"
      :visible="modalVisible"
      :loading="confirmLoading"
      :base-options="baseOptions"
      :action-type="actionType"
      @cancel="handleCancel"
      @ok="handleOk"
    />
  </div>
</template>

<script>

import EditPaymentRecord from './EditPaymentRecord.vue'
import { getQueryCollections, deleteCollection, exportCollections } from '@/api/paymentRecord.js'

import { queryBases } from '@/api/common.js'
import moment from 'moment'
import { excelDown, filterOption, inputKeydown } from '@/utils/utils.js'
import { pagination } from '@/constants/tableSetting'

const headerActions = [
  {
    title: '查询',
    type: 'primary',
    action: 'checkResource'
  }
]

const columns = [
  {
    title: '基地',
    dataIndex: 'baseName',
    key: 'baseName'
  },
  {
    title: '回款金额',
    dataIndex: 'collectionAmount',
    key: 'collectionAmount'
  },
  {
    title: '回款时间',
    dataIndex: 'collectionDate',
    key: 'collectionDate',
    scopedSlots: { customRender: 'collectionDate' }
  },
  {
    title: '运营年度',
    dataIndex: 'operateYear',
    key: 'operateYear'
  },
  {
    title: '操作',
    dataIndex: 'actions',
    key: 'actions',
    width: '150px',
    scopedSlots: { customRender: 'actions' }
  }
]

const addActions = [{
  title: '添加回款',
  type: 'primary',
  action: 'add',
  apis: ['@baseInfo/Add_Base']
},
{
  title: '导出',
  type: 'primary',
  action: 'exportResource',
  apis: ['@baseInfo/Export_Bases'],
  ghost: true
}]

const tableActions = [
  {
    title: '编辑',
    type: 'link',
    action: 'edit',
    apis: ['@baseInfo/Add_Base']
  },
  {
    title: '删除',
    type: 'link',
    action: 'delete',
    apis: ['@baseInfo/Add_Base']
  }
]
export default {
  components: {
    EditPaymentRecord
  },
  filters: {
    filterTime (time) {
      return moment(time).format('YYYY-MM-DD')
    }
  },
  data () {
    return {
      headerActions,
      columns,
      dataSource: [],
      loading: false,
      pagination,
      baseId: 0,
      baseOptions: [],
      tableActions,
      addActions,
      modalVisible: false,
      confirmLoading: false,
      initData: null,
      dialogTitle: null,
      form: {
        baseId: undefined
      },
      actionType: null
    }
  },
  created () {
    this.loading = true
    this.fetchData()
    this.fetchSearchOptions()
  },
  methods: {
    excelDown,
    filterOption,
    inputKeydown,
    moment,
    async fetchSearchOptions () {
      await queryBases().then((data) => {
        this.baseOptions = data || []
      })
    },
    checkResource () {
      this.pagination.current = 1
      this.fetchData()
    },
    // 异步获取数据
    async fetchData () {
      this.loading = true
      await getQueryCollections({
        pageIndex: this.pagination.current,
        pageSize: this.pagination.pageSize,
        baseId: this.form.baseId
      }).then((data) => {
        this.dataSource = data.result ? data.result : []
        this.pagination.total = data.totalRecords
      }
      )
      this.loading = false
    },
    getBaseId (vid) {
      this.baseId = vid
    },
    handleTableChange (pagination, filters, sorter) {
      this.pagination = { ...this.pagination, ...pagination }
      this.fetchData()// 获取表格数据的接口
    },
    // 添加回款
    addPaymentRecord () {
      this.modalVisible = true
      this.initData = {
        baseId: undefined,
        collectionAmount: undefined,
        collectionDate: null,
        operateYear: undefined
      }
      this.dialogTitle = '添加回款'
      this.actionType = '1'
    },
    editPaymentRecord (record) {
      this.modalVisible = true
      this.dialogTitle = '编辑回款'
      this.initData = record
      this.actionType = '0'
    },
    // 删除回款记录
    handleDelete (record) {
      this.$confirm({
        title: '确定删除该条记录吗？',
        okText: '确认删除',
        cancelText: '取消',
        onOk: async () => {
          await deleteCollection({
            collectionId: record.collectionId
          }).then((data) => {
            if (data) {
              this.$message.success('删除成功!')
              this.fetchData()
            } else {
              this.$message.error('存在关联信息，无法删除!')
            }
          })
        }
      })
    },
    inputChange (item) {
      this.modalVisible = item
    },
    handleCancel () {
      this.modalVisible = false
    },
    handleOk () {
      this.handleCancel()
      this.fetchData()
    },
    async exportCollections () {
      await exportCollections({
        baseId: this.form.baseId
      }).then((data) => {
        this.excelDown(data, '回款记录')
      })
    }
  }
}
</script>

<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 16px;
}
</style>
